import type { RouteRecordRaw } from 'vue-router'

const mediaLibraryRoutes: RouteRecordRaw[] = [
  {
    path: 'media-library',
    name: 'media-library',
    meta: {
      titleKey: 'routes.media-library.title',
      icon: 'Headset',
      helpKey: 'media-library'
    },
    component: () => import('@/views/media-library/MediaLibraryIndex.vue')
  }
]

export default mediaLibraryRoutes
